import {
  Callout as BPCallOut,
  ICalloutProps as IBPCallOutProps
} from "@blueprintjs/core";
import { FC } from "react";
import * as React from "react";

const CallOut: FC<IBPCallOutProps> = props => <BPCallOut {...props} />;
export default CallOut;
